import React from 'react';
import { render } from '@testing-library/react';
import { SideNav } from './SideNav';

describe('SideNav', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<SideNav title="Marketing" data-auto-sel="automation-selector">
				<SideNav.Item>Dashboard</SideNav.Item>
				<SideNav.Item>Campaigns</SideNav.Item>
				<SideNav.Item>Emails</SideNav.Item>
				<SideNav.Item>Audiences</SideNav.Item>
			</SideNav>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<SideNav title="Marketing">
				<SideNav.Item data-auto-sel="automation-selector">
					Dashboard
				</SideNav.Item>
				<SideNav.Item>Campaigns</SideNav.Item>
				<SideNav.Item>Emails</SideNav.Item>
				<SideNav.Item>Audiences</SideNav.Item>
			</SideNav>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
